import {
    selectDoc, toggleClass,
    toggleClassAll, selectAll,
    isVisible, hasClass, styles,
    event, selectArr, removeClass, addClass
} from "../utils/utils";

import {initSlider} from "../helpers/service.slider";

const props = {
    pageContainer: selectDoc('#PageContainer'),

    ctaSearch: selectDoc('#ctaSearch'),
    navSearchForm: selectDoc('#navSearchForm'),
    ctaCloseSearch: selectDoc('button.cta-close-search'),
    searchInput: selectDoc('#navSearchForm input.search-input'),
    showCount: 0,

    hideNavs: selectAll('.hide-link'),
    accountNav: selectDoc('.nav-link .account'),
    navSection: selectAll('.navigation')[0],
    bar: selectDoc('#navbar'),
    tops: selectArr('.top-section'),
    servicesNav: selectDoc('.header-services'),
    banner: selectDoc('#shopify-section-ws-banner'),
    logo: selectDoc('nav .verlas-logo'),
    burger: selectDoc('#burger'),
    nav: selectDoc('#navList'),
    promoClose: selectDoc('#promoClose'),
    promoBanner: selectDoc('.promo-banner'),
    offset: '',

    miniCartIcon: selectDoc('#cta-cart .cart'),
    miniCart: selectDoc('#ws-minicart'),

    accountIcon: selectDoc('#cta-account .account'),
    account: selectDoc('#ws-account'),
}

export const hideNavComponents = (mobile = true, minicart = true, account = true, search = true) => {
    if(mobile) {
        hideMobileNav();
    }
    if(minicart) {
        removeClass(selectDoc('#ws-minicart'), 'show')
        removeClass(selectDoc('#cta-cart .cart'), 'active')
    }
    if(account) {
        removeClass(selectDoc('#ws-account'), 'show');
        removeClass(selectDoc('#cta-account .account'), 'active');
    }
    if(search) {
        removeClass(selectDoc('#ctaSearch'), 'open');
        addClass(selectDoc('#navSearchForm'), 'hide');
    }
}

const observeOut = (e) => {
    if(props.o) {
        if (!props.o.contains(e.target) && isVisible(props.o)) {
            if (props.showCount > 0) {
                cleanOut(props.o, props.i);
            } else {
                props.showCount++;
            }
        }
    }
}
const cleanOut = () => {
    if(props.o && props.i) {
        removeClass(props.o, 'show')
        removeClass(props.i, 'active')

        addClass(props.o, 'hide')
        removeClass(props.i, 'open')
    }

    props.showCount = 0;
    removeClass(document.body, 'child-open');
    removeClass(document.body, 'no-scroll');
    document.removeEventListener('click', observeOut);
}
export const toggleCheckOutSide = (observed = null, icon = null) => {
    if(props.isObservingOutside || !observed) {
        props.isObservingOutside = false;
        props.o = null;
        props.i = null;
        cleanOut();
    } else {
        props.isObservingOutside = true;
        props.o = observed;
        props.i = icon;
        event(document, 'click', observeOut);
    }
}

/**
 * Nav toggle mobile
 */
const initMobileNav = async () => {
    initResize();
    initOverlayMenu();
};

export const hideMobileNav = () => {
    if (!props.isMobile) {
        // Stop body overflow
        document.body.style.removeProperty('top');
        window.scrollTo({
            top: (props.offset + 60),
            left: 0,
            behavior: 'smooth'
        });

        // Remove active classes
        removeClass(props.burger, 'burger-icon--active');
        removeClass(props.navSection, 'nav--overlay-active');
        removeClass(document.body, 'child-open');
        removeClass(document.body, 'no-scroll');
    }
}

export const toggleMobileNav = () => {
    if (hasClass(props.burger, 'burger-icon--active')) { //is active
        //Hide
        hideMobileNav();
    } else {
        //Hide other components
        hideNavComponents(false);

        //Show
        addClass(props.burger, 'burger-icon--active')
        addClass(props.navSection, 'nav--overlay-active')
        setTimeout(function () {
            addClass(document.body, 'no-scroll');
            addClass(document.body, 'child-open');
        }, 300)

        //Stop body overflow
        props.offset = window.pageYOffset;
        document.body.style.top = `-${props.offset + 60}px`;
    }
}

const initResize = () => {
    const mql = window.matchMedia('(min-width: 64em)');
    mql.addListener((e) => {
        if (e.matches) {
            props.isMobile = false;
            hideMobileNav();
        }
    });
}

const initOverlayMenu = () => {
    props.burger.addEventListener('click', function () {
        toggleMobileNav()
    });
}

/**
 * Accommodate navbar position and animations
 */
const navScroll = async () => {
    // Sticky Menu Functionality
    const initStick = () => {
        const events = ['scroll', 'load'];

        for (let i = 0; i < events.length; i++) {
            window.addEventListener(events[i], (e) => {
                if (window.pageYOffset > props.promoBanner.getBoundingClientRect().height) {
                    addClass(document.body, 'sticky')
                } else {
                    removeClass(document.body, 'sticky')
                }
                props.account.style.marginTop = (props.accountIcon.getBoundingClientRect().top + 50) + 'px'
            });
        }
    }

    initStick();
}

/**
 * Highlight nav title according to page
 * @returns {Promise<void>}
 */
const selectNav = async () => {
    let pathname = window.location.pathname;
    try {
        let currentNav = selectDoc(`.nav-link.${pathname.split('/').pop()}`)
        if (currentNav) {
            currentNav.classList.add('active')
        }
    } catch (e) {

    }
}

export const toggleSearch = (closeMenus = true) => {
    toggleClass(props.navSearchForm, 'hide');
    toggleClass(props.ctaSearch, 'open');

    if(hasClass(props.ctaSearch,'open')) {
        //Hide other components
        hideNavComponents(true,true,true, false);

        //Show
        toggleCheckOutSide();
        toggleCheckOutSide(props.navSearchForm, props.ctaSearch);
        addClass(document.body, 'child-open');
        addClass(document.body, 'no-scroll');
        props.searchInput.focus();
    } else {
        //Hide
        toggleCheckOutSide();
        closeMenus ? removeClass(document.body, 'child-open') : '';
        removeClass(document.body, 'no-scroll');
    }
}

const search = () => {
    props.ctaSearch.addEventListener('click', () => {
        toggleSearch();
    });
}

/**
 * OnClick banner links check if is external url and open on new tab
 */
const bannerAnchors = () => {
    selectArr('#shopify-section-ws-banner a').map(anchor => {
        let url = anchor.getAttribute('href')
        if (url.indexOf("http://") == 0 || url.indexOf("https://") == 0 || url.includes('newtab')) {
            event(anchor, 'click', function (e) {
                e.preventDefault();
                window.open(anchor.href, '_blank');
            })
        }
    })
}

const promo = () => {
    props.promoClose.addEventListener('click', () => props.banner.remove())
}

const initializer = () => {
    initSlider('.promo-slider', {
        rewind: true,
        autoplay: 5000,
        hoverpause: true,
        bound: true,
        gap: 0,
        peek: {
            before: 0,
            after: 0
        }
    });
    initMobileNav();
    navScroll();
    selectNav();
    bannerAnchors();
    search();
    promo();
}

export const Nav = {
    init: () => initializer()
}
